import { BaseUrl } from "../../BaseUrl/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithoutAuthorization,
} from "../ApiMethod/ApiMethod";

export const CurrentBlogData = async (params) => {
  const url = `${BaseUrl}/Blog`;
  const res = await postApiWithoutAuthorization(url, params);
  return res;
};
export const BlogCategoryList = async () => {
  const url = `${BaseUrl}/BlogCategoryList`;
  const res = await getApiWithAuthorization(url);
  return res;
};
